<div class="vp-wrapper">
  <div class="vp-card">
    <!-- Logo -->
    <div class="vp-logo">
      <img alt="Logo" src="/logo-login.svg"/>
    </div>
    <h2 class="vp-title">Contact Verification</h2>
    <p class="vp-subtitle">Verify your email and mobile number to continue.</p>
    <form [formGroup]="verifyForm" class="vp-form">
      <!-- EMAIL SECTION -->
      <div class="vp-field-block">
        <div class="vp-field-header">
          <div class="vp-field-icon email-icon">
            <svg fill="none" height="18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg">
              <rect height="16" rx="2" width="20" x="2" y="4"/>
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
            </svg>
          </div>
          <span class="vp-field-title">Email Address</span>
          <span *ngIf="emailState.verified" class="vp-badge verified">
            <svg fill="none" height="12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" viewBox="0 0 24 24" width="12" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"/></svg>
            Verified
          </span>
        </div>
        <div class="vp-input-row">
          <input [value]="email" class="vp-input" readonly/>
          <button
            (click)="sendOtp('email')"
            *ngIf="!emailState.verified"
            [disabled]="emailState.cooldown > 0"
            class="vp-btn vp-btn--outline">
            {{ emailState.sent ? 'Resend OTP' : 'Get OTP' }}
          </button>
          <button (click)="resetField('email')" *ngIf="emailState.verified" class="vp-btn vp-btn--ghost">
            Change
          </button>
        </div>
        <div *ngIf="emailState.sent && !emailState.verified" class="vp-otp-section">
          <p class="vp-otp-hint">Enter the OTP sent to <strong>{{ email }}</strong></p>
          <div class="vp-otp-row">
            <input
              [ngClass]="{ 'vp-input--error': verifyForm.get('emailOtp')?.invalid && verifyForm.get('emailOtp')?.touched }"
              class="vp-input vp-input--otp"
              formControlName="emailOtp"
              placeholder="Enter OTP"/>
            <button
              (click)="verifyOtp('email')"
              [disabled]="verifyForm.get('emailOtp')?.invalid"
              class="vp-btn vp-btn--primary">
              Verify
            </button>
          </div>
          <p *ngIf="emailState.errorMessage" class="vp-error-msg">{{ emailState.errorMessage }}</p>
          <p *ngIf="emailState.cooldown > 0" class="vp-cooldown">
            Resend OTP in <strong>{{ emailState.cooldown }}s</strong>
          </p>
        </div>
      </div>
      <!-- DIVIDER -->
      <div class="vp-divider"></div>
      <!-- MOBILE SECTION -->
      <div class="vp-field-block">
        <div class="vp-field-header">
          <div class="vp-field-icon mobile-icon">
            <svg fill="none" height="18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg">
              <rect height="20" rx="2" width="14" x="5" y="2"/>
              <line x1="12" x2="12.01" y1="18" y2="18"/>
            </svg>
          </div>
          <span class="vp-field-title">Mobile Number</span>
          <span *ngIf="mobileState.verified" class="vp-badge verified">
            <svg fill="none" height="12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" viewBox="0 0 24 24" width="12" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"/></svg>
            Verified
          </span>
        </div>
        <div class="vp-input-row">
          <input [value]="mobile" class="vp-input" readonly/>
          <button
            (click)="sendOtp('mobile')"
            *ngIf="!mobileState.verified"
            [disabled]="mobileState.cooldown > 0"
            class="vp-btn vp-btn--outline">
            {{ mobileState.sent ? 'Resend OTP' : 'Get OTP' }}
          </button>
          <button (click)="resetField('mobile')" *ngIf="mobileState.verified" class="vp-btn vp-btn--ghost">
            Change
          </button>
        </div>
        <div *ngIf="mobileState.sent && !mobileState.verified" class="vp-otp-section">
          <p class="vp-otp-hint">Enter the OTP sent to <strong>{{ mobile }}</strong></p>
          <div class="vp-otp-row">
            <input
              [ngClass]="{ 'vp-input--error': verifyForm.get('mobileOtp')?.invalid && verifyForm.get('mobileOtp')?.touched }"
              class="vp-input vp-input--otp"
              formControlName="mobileOtp"
              placeholder="Enter OTP"/>
            <button
              (click)="verifyOtp('mobile')"
              [disabled]="verifyForm.get('mobileOtp')?.invalid"
              class="vp-btn vp-btn--primary">
              Verify
            </button>
          </div>
          <p *ngIf="mobileState.errorMessage" class="vp-error-msg">{{ mobileState.errorMessage }}</p>
          <p *ngIf="mobileState.cooldown > 0" class="vp-cooldown">
            Resend OTP in <strong>{{ mobileState.cooldown }}s</strong>
          </p>
        </div>
      </div>
      <!-- CONTINUE -->
      <div class="vp-footer">
        <p *ngIf="continueError" class="vp-error-msg">{{ continueError }}</p>
        <button
          (click)="continue()"
          [disabled]="!emailState.verified || !mobileState.verified"
          class="vp-btn vp-btn--primary vp-btn--full">
          Continue
          <svg fill="none" height="16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
            <line x1="5" x2="19" y1="12" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </button>
      </div>
    </form>
  </div>
</div>
